export default __webpack_public_path__ + "static/media/six.06453aab.jpg";